import React from 'react';

import styles from 'assets/jss/material-dashboard-pro-react/components/schedulerToolbar';
import withStyles from '@material-ui/core/styles/withStyles';
import { capitalize } from "lodash";

import Tooltip from '@material-ui/core/Tooltip';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CustomTextField from 'components/CustomTextField/CustomTextField';
import AsyncAutocomplete from 'components/AsyncAutocomplete/AsyncAutocomplete';

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";

import ViewListIcon from '@material-ui/icons/ViewList';
import NewAppointmentIcon from 'assets/img/Scheduler_NewAppointment.svg';
import VacationIcon from 'assets/img/Scheduler_Vacation.svg';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

import { can } from 'utils/permissions/permissionsChecker';
import permissionsMap from 'utils/permissions/permissionsMap';

import { searchCustomerRepresentative } from 'services/user.service';

const views = [
	'month',
	'week',
	'day',
];

class Toolbar extends React.Component {
	changeView = (view) => {
		this.props.changeView(view);
		this.props.onView(view);
	}

	render() {
		const {
			label,
			onNavigate,
			createAppointment,
			createVacation,
			classes,
			contactCenterList,
			contactCenter,
			setContactCenter,
			selectedUser,
			setSelectedUser,
			toggleViewMode,
		} = this.props;

		const goToCurrent = () => {
			onNavigate('TODAY');
		};

		const goToBack = () => {
			onNavigate('PREV');
		};

		const goToNext = () => {
			onNavigate('NEXT');
		};

		return (
			<div className={classes.wrapper}>
				<GridContainer
					justify="space-between"
					direction="row"
					className={classes.container}
				>
					<GridItem xs={6} sm={2} md={3} lg={3}>
						<span className={classes.label} >
							{label}
						</span>
					</GridItem>
					<GridItem xs={6} sm={8} md={7} lg={7}>
						<GridContainer justify="center" alignItems="flex-end">
							{can(permissionsMap.scheduler.items.calendarViewForAdmin.read) && (
								<div className={`${classes.select} ${classes.customerRepSelect}`}>
									<AsyncAutocomplete
										autocompleteClassName={classes.autocomplete}
										label="Customer Representative"
										value={selectedUser}
										optionLabel="fullName"
										searchHandler={searchCustomerRepresentative}
										isPhoneSearch={false}
										searchOptions={{
											sortBy: [{ id: "fullName", desc: false }],
										}}
										onChange={(val) => {
											setSelectedUser(val);
										}}
									/>
								</div>
							)}
							<div className={`${classes.select} ${classes.callCenterSelect}`}>
								<Autocomplete
									className={classes.autocomplete}
									options={contactCenterList.filter((option) => option && option.label)}
									autoComplete
									includeInputInList
									value={contactCenter}
									getOptionLabel={(option) => option.label || ''}
									renderInput={(params) =>
										<CustomTextField
											{...params}
											label="Contact Center"
										/>
									}
									onChange={(e, val) => {
										setContactCenter((val && val._id) || 'all');
									}}
								/>
							</div>
							<div className={`${classes.select} ${classes.viewSelect}`}>
								<Autocomplete
									className={classes.autocomplete}
									disableClearable
									options={views}
									autoComplete
									includeInputInList
									value={this.props.view}
									getOptionLabel={capitalize}
									renderInput={(params) => <CustomTextField {...params} />}
									onChange={(e, view) => {
										this.changeView(view || 'week');
									}}
								/>
							</div>
							<div className={classes.navigation}>
								<Button
									color="warning"
									justIcon
									onClick={goToBack}
									className={classes.button}
								>
									<ArrowBackIosIcon className={classes.arrowBack} />
								</Button>
								<Button
									color="warning"
									justIcon
									onClick={goToNext}
									className={classes.button}
								>
									<ArrowForwardIosIcon fontSize="inherit" />
								</Button>
								<Button
									onClick={goToCurrent}
									className={classes.button}
								>
									Today
								</Button>
							</div>
						</GridContainer>
					</GridItem>
					<GridItem xs={12} sm={2} md={2} lg={2}>
						<GridContainer justify="flex-end"  alignItems="flex-end">
							{can(permissionsMap.scheduler.items.calendarViewForAdmin.read) && (
								<Tooltip
									arrow
									title="List view"
								>
									<Button
										color="transparent"
										justIcon
										onClick={toggleViewMode}
										className={classes.rightButton}
									>
										<ViewListIcon />
									</Button>
								</Tooltip>
							)}
							<Tooltip
								arrow
								title="Create Vacation"
							>
								<Button
									color="transparent"
									justIcon
									onClick={createVacation}
									className={classes.rightButton}
								>
									<img
										src={VacationIcon}
										alt="Vacation icon"
									/>
								</Button>
							</Tooltip>
							<Tooltip
								arrow
								title="Create Appointment"
							>
								<Button
									color="transparent"
									justIcon
									onClick={createAppointment}
									className={classes.rightButton}
								>
									<img
										src={NewAppointmentIcon}
										alt="New appointment icon"
									/>
								</Button>
							</Tooltip>
						</GridContainer>
					</GridItem>
				</GridContainer>
			</div>
		);
	}
}

export default withStyles(styles)(Toolbar);
